export default [
    {title: 'Fantasy'},
    {title: 'Music'},
    {title: 'Sports'},
    {title: 'Outdoors'},
    {title: 'Indoors'},
    {title: 'Space'},
    {title: 'Underwater'},
    {title: 'Patterns'}
];
